import styled from "styled-components";

const SKUsWrapper = styled.div`
  .sku-card:not(:last-child) {
    border-bottom: 0.5px solid ${({ theme }) => theme.COLORS.LightBlue};
  }
`;

export default SKUsWrapper;
